import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { LockIcon, EyeClosedIcon, EyeOpenIcon } from '../icons'


const PasswordInput = ({ toggleAriaLabel = 'Toggle password visibility', children, ...controlProps }) => {
    const [isVisible, setIsVisible] = useState(false)

    return (
        <>
            <div className="form-control-icon-left form-control-icon-right">
                <span className="form-control-icon" aria-hidden="true">
                    <LockIcon />
                </span>
                <Form.Control
                    {...controlProps}
                    type={isVisible ? 'text' : 'password'}
                />
                <button
                    type="button"
                    className="form-control-icon form-control-icon-button is-right"
                    onClick={() => setIsVisible((prev) => !prev)}
                    aria-label={toggleAriaLabel}
                >
                    {isVisible ? <EyeOpenIcon size={20} /> : <EyeClosedIcon size={20} />}
                </button>
            </div>
            {children}
        </>
    )
}

export default PasswordInput
